<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { ref, watchEffect } from "vue";

const props = defineProps(["class", "style", "innerClass", "innerStyle", "error", "label", "tooltip", "prefix", "prefixClass", "modelValue"]);

const emit = defineEmits(["update:modelValue"]);

const input = ref(null);

function emitValue(event) {
	let value = event.target.value.trim();

	if (event.target.type === "url" && value.length > 0 && !value.match(/^https?:\/\//i))
		value = "https://" + value;

	emit("update:modelValue", value);
}

watchEffect(() => {
	if (input.value)
		input.value.setCustomValidity(typeof props.error !== "undefined" ? props.error : "");
});
</script>

<template>
	<label :class="class" :style="style" class="vui-input">
		<template v-if="label">
			<span class="label">{{ label }}</span>
			<span v-if="!$attrs.required && $attrs.required !== ''" class="badge">{{ $gettext("optional") }}</span>
			<i v-if="tooltip || $slots.tooltip" class="fa-solid fa-square-info tooltip tooltip-right" @click.prevent>
				<div class="tooltip-content"><slot name="tooltip">{{ tooltip }}</slot></div>
			</i>
		</template>
		<div class="input-wrapper">
			<span v-if="prefix || prefixClass" :class="prefixClass" class="prefix">{{ prefix }}</span>
			<input
				ref="input"
				:class="innerClass"
				:style="innerStyle"
				:value="modelValue"
				v-bind="$attrs"
				@change="emitValue($event); $forceUpdate()"
			>
		</div>
	</label>
</template>
